import { Image } from "@tiptap/extension-image";
import { Table } from "@tiptap/extension-table";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableRow } from "@tiptap/extension-table-row";
import { EditorContent, useEditor } from "@tiptap/react";
import { ScrollArea } from "@/components/ui/scroll-area";
import StarterKit from "@tiptap/starter-kit";
import { useRef } from "react";
import { Markdown } from "tiptap-markdown";
import { cn } from "@/lib/utils";

interface MarkdownViewProps {
	value: string;
	className?: string;
	/** Format of `value`; `"html"` for raw HTML (e.g. Outlook signatures) — preserves inline HTML through the parser. */
	format?: "markdown" | "html";
}

function MarkdownView({
	value,
	className,
	format = "markdown",
}: MarkdownViewProps) {
	const lastSyncedValue = useRef<string | null>(null);
	const editor = useEditor({
		editable: false,
		extensions: [
			StarterKit,
			Table.configure({ resizable: false }),
			TableRow,
			TableHeader,
			TableCell,
			Image.configure({ inline: true, allowBase64: true }),
			Markdown.configure({ html: format === "html" }),
		],
		onCreate: ({ editor: e }) => {
			if (value) {
				e.commands.setContent(value);
				lastSyncedValue.current = value;
			}
		},
	});

	if (editor && value !== lastSyncedValue.current) {
		lastSyncedValue.current = value;
		editor.commands.setContent(value);
	}

	return (
		<ScrollArea orientation="horizontal">
			<EditorContent
				editor={editor}
				className={cn(
					"prose prose-sm dark:prose-invert max-w-none [&_.tiptap]:outline-none [&_.tiptap_table]:border-collapse [&_.tiptap_td]:border [&_.tiptap_td]:border-border [&_.tiptap_td]:p-2 [&_.tiptap_th]:border [&_.tiptap_th]:border-border [&_.tiptap_th]:bg-muted [&_.tiptap_th]:p-2 [&_.tiptap_th]:font-semibold",
					className,
				)}
			/>
		</ScrollArea>
	);
}

export type { MarkdownViewProps };
export { MarkdownView };
